<template src="./index.html"></template>

<script>
import { format, parseISO } from 'date-fns'
import PrefixFormDialog from './PrefixFormDialog.vue'

export default {
  name: 'barcodePrefixStatus',

  components: { PrefixFormDialog },

  data() {
    return {
      loading: false,
      prefixes: [],
      activePrefix: null,
      page: { pageSize: 50, currentPage: 0, totalPage: 1 },
      dialogVisible: false,
      dialogMode: 'create',
      editingPrefix: null,
    }
  },

  watch: {
    'page.currentPage'() { this.loadPrefixes() },
  },

  created() {
    this.loadPrefixes()
  },

  methods: {
    getRemaining(p) {
      return p.max_sequence - p.used_codes
    },

    usagePct(p) {
      if (!p.max_sequence) return 0
      return Math.round((p.used_codes / p.max_sequence) * 100)
    },

    formatDate(val) {
      if (!val) return '-'
      try { return format(parseISO(val), 'yyyy-MM-dd HH:mm') } catch { return val }
    },

    loadPrefixes() {
      this.loading = true
      const params = { page: this.page.currentPage, limit: this.page.pageSize }
      this.$store.dispatch('GET_BARCODE_PREFIXES', params)
        .then((result) => {
          const data = result.data || result
          const list = data.prefixes || []
          this.prefixes = [...list].sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
          this.activePrefix = list.find((p) => p.is_active) || null
          this.page.totalPage = data.pagination ? data.pagination.totalPages : 1
        })
        .catch(() => { this.prefixes = []; this.activePrefix = null })
        .finally(() => { this.loading = false })
    },

    openCreate() {
      this.editingPrefix = null
      this.dialogMode = 'create'
      this.dialogVisible = true
    },

    openEdit(row) {
      this.editingPrefix = row
      this.dialogMode = 'edit'
      this.dialogVisible = true
    },
  },
}
</script>
